const en = {
  "closeWalkingNotice": "Dismiss walking route notice",
  "routeCalculationError": "The route could not be calculated. Your stops are still available.",
  "locating": "Finding your location…",
  "locationUnavailable": "Location is not available on this device.",
  "locationDenied": "Allow location access to show your position on the map.",
  "nearbyPermission": "Allow location access to find chargers around you.",
  "needLocation": "Your current location is needed for nearby chargers.",
  "chargeSaveError": "Charge target could not save. The previous target is restored; adjust it to retry.",
  "networkSaveError": "Network preference could not save. Please try again.",
  "alternativeError": "Chargers could not load. Refresh to try again.",
  "replaceError": "Charger could not replace the stop. Your current stop is unchanged; try again.",
  "replacingCharger": "Changing charger…",
  "noRouteChargers": "No charger was returned within 60 km of this route point.",
  "emptyChargerHelp": "Try refreshing or choose another search area.",
  "noNearbyChargers": "No fast charger was returned within 50 km of you.",
  "slideTarget": "Slide to change · autosaves",
  "preferNetwork": "Prefer {{network}}",
  "showLocation": "Show my location",
  "backup": "CHARGER BACKUP",
  "chooseCharger": "Choose a charger",
  "selectedScope": "Days {{days}} · {{count}} planned stops",
  "selectedScopePrevious": "Days {{days}} · previous day finish + {{count}} planned stops",
  "days": "Days {{days}}",
  "filter_all": "All",
  "filter_places": "Places",
  "filter_charge": "Charge",
  "filter_fuel": "Fuel",
  "filter_potential": "Suggestions",
  "clearFilters": "Clear map content filters",
  "filters": "Map filters",
  "filtersHeading": "FILTERS",
  "fitPoints": "Fit visible points",
  "viewOptions": "Map view options",
  "view": "Map view",
  "closeFilters": "Close map filters",
  "daysHeading": "Days",
  "mapDays": "Map days",
  "dayUnit": "days",
  "points": "Points",
  "pointType": "Map point type",
  "routeDisplay": "Route display",
  "routeColors": "Route colors",
  "color_day": "By day",
  "color_leg": "By leg",
  "placeNames": "Place names",
  "durationDistance": "Duration and distance",
  "lineHelp": "Driving is solid. Walking is dashed.",
  "style": "Map style",
  "style_roadmap": "Map",
  "style_satellite": "Satellite",
  "style_hybrid": "Hybrid",
  "previewDay": "Preview a day",
  "previewHelp": "Follow the route, stop by stop",
  "walkingNote": "Walking routes may miss sidewalks or pedestrian paths. Use caution.",
  "resize": "Resize map details",
  "routeTools": "ROUTE TOOLS",
  "peek": "{{count}} points · Detour · Along the way",
  "navigate": "Navigate",
  "tools": "Map tools",
  "detour": "Detour",
  "alongRoute": "Along route",
  "visible": "VISIBLE ON THE MAP",
  "pointsCount": "{{count}} points",
  "potentialCount": "{{count}} potential",
  "waitingDecision": "Potential · waiting for decision",
  "noPoints": "No points match these filters.",
  "tryPlace": "Try a place before it touches the plan.",
  "comparePlace": "Compare any place",
  "betterStop": "A better next stop.",
  "stopHelp": "Charging, food, coffee, shops, toilets and parking — near a stop or along your route.",
  "findWay": "Find on the way",
  "chargerArea": "Charger search area",
  "alongTheRoute": "Along the route",
  "lowDetour": "Low-detour chargers",
  "aroundMe": "Around me",
  "fastNearby": "Fast chargers nearby",
  "refreshAlternatives": "Refresh charger availability and alternatives",
  "alternativeMap": "Alternative chargers map",
  "currentCharger": "Current charger",
  "yourLocation": "Your location",
  "you": "You",
  "currentStop": "Current stop",
  "options": "Options",
  "comparing": "Comparing sensible options…",
  "liveUnavailable": "Live status unavailable",
  "fromYou": "from you",
  "fromRoute": "from route",
  "impactUnavailable": "Impact unavailable",
  "useThis": "Use this",
  "loadOptions": "Load {{count}} more options",
  "mapError": "Map could not start",
  "mapLoading": "Loading the map…",
  "mapKey": "Map key needed",
  "mapRetry": "The route tools are still available. Reopen this tab to retry.",
  "offlinePlan": "Your plan is still available offline.",
  "calculating": "Calculating…",
  "stops": "{{count}} stops",
  "closePlace": "Close place details",
  "groupSuggestion": "Group suggestion",
  "voteTogether": "Vote together",
  "arriveBy": "Arrive by",
  "arrivalMode": "Arrival travel mode",
  "availableNow": "Available now",
  "connectorData": "Connector data",
  "nextLocation": "NEXT LOCATION",
  "alternatives": "Alternatives",
  "maps": "Maps",
  "findAround": "Find around this stop",
  "viewDecision": "View decision",
  "stationData": "Station data varies by provider",
  "updatedNow": "updated now",
  "updatedMinutes": "updated {{count}}m ago",
  "updatedHours": "updated {{count}}h ago",
  day: 'Day {{number}}', closePreview: 'Close day preview', previewHeading: 'DAY PREVIEW', previewSelect: 'Preview day', previewRegion: 'Day route preview',
  arrivalIncluded: 'Arrival included', todaysStops: 'Today’s stops', hideArrival: 'Hide long arrival', includeArrival: '+ Include arrival',
  perspective: 'Preview perspective', tiltedView: 'Tilted map view', pauseFollow: 'Pause camera follow', resumeFollow: 'Resume camera follow', following: 'Following', followRoute: 'Follow route',
  previewComplete: 'Day preview complete', start: 'Start', finish: 'Finish', nextStop: 'Next stop', streetView: 'Open this stop in Google Street View', streetHelp: 'Opens Google Maps; imagery depends on coverage', street: 'Street ↗',
  dayProgress: 'Day progress', previousStop: 'Previous stop', playDay: 'Play day', pauseDay: 'Pause day', playbackSpeed: 'Playback speed',
  previewDisclaimer: 'Preview, not navigation', pauseCameraHelp: 'Explore the map to pause camera follow.', noPreviewRoute: 'A calculated route between two mapped stops is needed for this day.', previewPosition: 'Route preview position',
  compareHeading: 'DETOUR IMPACT', tryTitle: 'Try a place', alongTitle: 'Find along the route', compareHelp: 'Choose a place to see how it changes your route.',
  placement: 'Route placement', changePlacement: 'Change placement', insertAfter: 'Insert after', insertBefore: 'Before', addToDay: 'Add to day', between: '{{from}} → {{to}}',
  searchNear: 'Search near {{place}}', searchBetween: 'Search {{type}} between {{from}} and {{to}}', route: 'the route', comparingRoads: 'Comparing both roads…',
  compareError: 'The route could not be compared. Your place is kept; try again.', compareAgain: 'Compare again', noCompareRoute: 'Add two mapped stops to compare a place.', routeChanged: 'The route or vehicle changed. Compare your place again for a current estimate.',
  ifAdded: 'IF WE ADD IT', arrivalAtStop: '{{value}}% at this stop', currentRoute: 'Current route', proposedRoute: 'With this stop', addNow: 'Add now', askGroup: 'Ask the group',
  adding: 'Adding…', proposing: 'Sending…', addError: 'The stop could not be added. Your choice is kept; try again.', proposalError: 'The group proposal could not be sent. Try again.',
  editorHelp: 'An editor can add this point or take it to the group.', proposalHelp: 'A proposal stays on the map until the group decides.', proposalTitle: 'Add {{place}} to the route?', potentialBetween: 'Potential stop between {{from}} and {{to}}.', potentialStop: 'Potential route stop.', addedBetween: 'Added between {{from}} and {{to}}.', chargerRefreshError: 'Charger details could not refresh. Try again.'
};
const tr: Record<keyof typeof en, string> = {
  "closeWalkingNotice": "Yürüyüş rotası uyarısını kapat",
  "routeCalculationError": "Rota hesaplanamadı. Duraklarını kullanmaya devam edebilirsin.",
  "locating": "Konumun bulunuyor…",
  "locationUnavailable": "Bu cihazda konum alınamıyor.",
  "locationDenied": "Konumunu haritada görmek için konum izni ver. Tekrar deneyebilir veya durakları kullanabilirsin.",
  "nearbyPermission": "Yakındaki şarj istasyonları için konum izni gerekli. Yenile ile tekrar deneyebilirsin.",
  "needLocation": "Yakındaki şarj istasyonları için konumun gerekli.",
  "chargeSaveError": "Şarj hedefi kaydedilemedi. Önceki hedef geri yüklendi; tekrar ayarlayabilirsin.",
  "networkSaveError": "Şarj ağı tercihi kaydedilemedi. Tekrar dene.",
  "alternativeError": "Şarj istasyonları yüklenemedi. Yenile ile tekrar dene.",
  "replaceError": "Şarj durağı değiştirilemedi. Mevcut durak korunuyor; tekrar dene.",
  "replacingCharger": "Şarj noktası değiştiriliyor…",
  "noRouteChargers": "Bu rota noktasının 60 km çevresinde şarj istasyonu bulunamadı.",
  "emptyChargerHelp": "Yenileyebilir veya başka bir arama alanı seçebilirsin.",
  "noNearbyChargers": "Konumunun 50 km çevresinde hızlı şarj istasyonu bulunamadı.",
  "slideTarget": "Değiştirmek için kaydır; otomatik kaydolur",
  "preferNetwork": "{{network}} ağını tercih et",
  "showLocation": "Konumumu göster",
  "backup": "ALTERNATİF ŞARJ",
  "chooseCharger": "Şarj istasyonu seç",
  "selectedScope": "{{days}}. günler · {{count}} planlanan durak",
  "selectedScopePrevious": "{{days}}. günler · önceki günün bitişi + {{count}} planlanan durak",
  "days": "{{days}}. günler",
  "filter_all": "Tümü",
  "filter_places": "Yerler",
  "filter_charge": "Şarj",
  "filter_fuel": "Yakıt",
  "filter_potential": "Öneriler",
  "clearFilters": "Harita filtrelerini temizle",
  "filters": "Harita filtreleri",
  "filtersHeading": "FİLTRELER",
  "fitPoints": "Görünen noktaları sığdır",
  "viewOptions": "Harita görünüm seçenekleri",
  "view": "Harita görünümü",
  "closeFilters": "Harita filtrelerini kapat",
  "daysHeading": "Günler",
  "mapDays": "Haritadaki günler",
  "dayUnit": "gün",
  "points": "Noktalar",
  "pointType": "Harita noktası türü",
  "routeDisplay": "Rota görünümü",
  "routeColors": "Rota renkleri",
  "color_day": "Güne göre",
  "color_leg": "Bölüme göre",
  "placeNames": "Yer adları",
  "durationDistance": "Süre ve mesafe",
  "lineHelp": "Sürüş düz çizgi, yürüyüş kesik çizgiyle gösterilir.",
  "style": "Harita stili",
  "style_roadmap": "Harita",
  "style_satellite": "Uydu",
  "style_hybrid": "Karma",
  "previewDay": "Günü izle",
  "previewHelp": "Rotayı durak durak takip et",
  "walkingNote": "Yürüyüş rotası tüm kaldırımları ve yaya yollarını göstermeyebilir. Yerel koşulları kontrol et.",
  "resize": "Harita ayrıntılarını genişlet veya daralt",
  "routeTools": "ROTA ARAÇLARI",
  "peek": "{{count}} nokta · Sapma · Yol üstünde",
  "navigate": "Yol tarifi",
  "tools": "Harita araçları",
  "detour": "Sapma",
  "alongRoute": "Rota boyunca",
  "visible": "HARİTADA GÖRÜNENLER",
  "pointsCount": "{{count}} nokta",
  "potentialCount": "{{count}} öneri",
  "waitingDecision": "Öneri; karar bekliyor",
  "noPoints": "Bu filtrelere uyan nokta yok.",
  "tryPlace": "Plana eklemeden önce bir yeri dene.",
  "comparePlace": "Bir yeri karşılaştır",
  "betterStop": "Sıradaki güzel mola.",
  "stopHelp": "Şarj, yemek, kahve, market, tuvalet ve otopark. Durak çevresinde veya rota boyunca ara.",
  "findWay": "Yol üstünde bul",
  "chargerArea": "Şarj arama alanı",
  "alongTheRoute": "Rota boyunca",
  "lowDetour": "Az sapmalı istasyonlar",
  "aroundMe": "Yakınımda",
  "fastNearby": "Yakındaki hızlı istasyonlar",
  "refreshAlternatives": "Şarj müsaitliğini ve alternatifleri yenile",
  "alternativeMap": "Alternatif şarj haritası",
  "currentCharger": "Mevcut şarj durağı",
  "yourLocation": "Konumun",
  "you": "Sen",
  "currentStop": "Mevcut durak",
  "options": "Seçenekler",
  "comparing": "Uygun seçenekler karşılaştırılıyor…",
  "liveUnavailable": "Canlı durum bilinmiyor",
  "fromYou": "konumundan",
  "fromRoute": "rota noktasından",
  "impactUnavailable": "Rota etkisi hesaplanamadı",
  "useThis": "Bunu kullan",
  "loadOptions": "{{count}} seçenek daha yükle",
  "mapError": "Harita açılamadı",
  "mapLoading": "Harita yükleniyor…",
  "mapKey": "Harita bağlantısı gerekli",
  "mapRetry": "Rota araçları kullanılabilir. Tekrar denemek için sekmeyi yeniden aç.",
  "offlinePlan": "Planın çevrimdışı kullanılabilir.",
  "calculating": "Hesaplanıyor…",
  "stops": "{{count}} durak",
  "closePlace": "Yer ayrıntılarını kapat",
  "groupSuggestion": "Grup önerisi",
  "voteTogether": "Birlikte karar ver",
  "arriveBy": "Ulaşım şekli",
  "arrivalMode": "Durağa ulaşım şekli",
  "availableNow": "Şu an müsait",
  "connectorData": "Soket bilgisi",
  "nextLocation": "SONRAKİ DURAK",
  "alternatives": "Alternatifler",
  "maps": "Haritalar",
  "findAround": "Bu durak çevresinde bul",
  "viewDecision": "Kararı aç",
  "stationData": "İstasyon bilgisi sağlayıcıya göre değişir",
  "updatedNow": "şimdi güncellendi",
  "updatedMinutes": "{{count}} dk önce güncellendi",
  "updatedHours": "{{count}} sa önce güncellendi",
  day: '{{number}}. gün', closePreview: 'Gün önizlemesini kapat', previewHeading: 'GÜNÜ İZLE', previewSelect: 'İzlenecek gün', previewRegion: 'Günün rota önizlemesi',
  arrivalIncluded: 'Geliş yolu dahil', todaysStops: 'Bugünün durakları', hideArrival: 'Uzun geliş yolunu gizle', includeArrival: '+ Geliş yolunu ekle',
  perspective: 'Önizleme açısı', tiltedView: 'Eğimli harita görünümü', pauseFollow: 'Kamera takibini duraklat', resumeFollow: 'Kamera takibini sürdür', following: 'Takip ediliyor', followRoute: 'Rotayı takip et',
  previewComplete: 'Gün önizlemesi tamamlandı', start: 'Başlangıç', finish: 'Bitiş', nextStop: 'Sıradaki durak', streetView: 'Bu durağı Google Sokak Görünümü’nde aç', streetHelp: 'Google Haritalar açılır; görüntüler bölgeye göre değişir', street: 'Sokak ↗',
  dayProgress: 'Gün ilerlemesi', previousStop: 'Önceki durak', playDay: 'Günü oynat', pauseDay: 'Günü duraklat', playbackSpeed: 'Oynatma hızı',
  previewDisclaimer: 'Rota önizlemesi; navigasyon yerine geçmez', pauseCameraHelp: 'Haritayı hareket ettirince kamera takibi duraklar.', noPreviewRoute: 'Bu gün için konumlu iki durak arasında hesaplanmış bir rota gerekli.', previewPosition: 'Rota önizleme konumu',
  compareHeading: 'SAPMA ETKİSİ', tryTitle: 'Bir yeri dene', alongTitle: 'Rota boyunca bul', compareHelp: 'Bir yer seç; rotaya etkisini birlikte görelim.',
  placement: 'Rotadaki yeri', changePlacement: 'Yerleşimi değiştir', insertAfter: 'Bu duraktan sonra', insertBefore: 'Bu duraktan önce', addToDay: 'Eklenecek gün', between: '{{from}} → {{to}}',
  searchNear: '{{place}} yakınında ara', searchBetween: '{{from}} ile {{to}} arasında {{type}} ara', route: 'rota', comparingRoads: 'İki rota karşılaştırılıyor…',
  compareError: 'Rota karşılaştırılamadı. Seçtiğin yer korunuyor; tekrar dene.', compareAgain: 'Tekrar karşılaştır', noCompareRoute: 'Bir yeri karşılaştırmak için konumlu iki durak ekle.', routeChanged: 'Rota veya araç değişti. Güncel tahmin için seçtiğin yeri tekrar karşılaştır.',
  ifAdded: 'EKLERSEK', arrivalAtStop: 'Bu durağa varışta %{{value}}', currentRoute: 'Mevcut rota', proposedRoute: 'Bu durakla', addNow: 'Şimdi ekle', askGroup: 'Gruba sor',
  adding: 'Ekleniyor…', proposing: 'Gönderiliyor…', addError: 'Durak eklenemedi. Seçimin korunuyor; tekrar dene.', proposalError: 'Grup önerisi gönderilemedi. Tekrar dene.',
  editorHelp: 'Bir düzenleyici bu yeri plana ekleyebilir veya gruba sorabilir.', proposalHelp: 'Grup karar verene kadar öneri haritada kalır.', proposalTitle: '{{place}} rotaya eklensin mi?', potentialBetween: '{{from}} ile {{to}} arasında önerilen durak.', potentialStop: 'Rotaya önerilen durak.', addedBetween: '{{from}} ile {{to}} arasına eklendi.', chargerRefreshError: 'Şarj bilgileri yenilenemedi. Tekrar dene.'
};
const sv: Record<keyof typeof en, string> = {
  "closeWalkingNotice": "Stäng information om gångvägen",
  "routeCalculationError": "Rutten kunde inte beräknas. Dina stopp är fortfarande tillgängliga.",
  "locating": "Hittar din plats…",
  "locationUnavailable": "Positionen är inte tillgänglig på den här enheten.",
  "locationDenied": "Tillåt platsåtkomst för att visa din position. Du kan försöka igen eller använda stoppen.",
  "nearbyPermission": "Platsåtkomst krävs för laddare i närheten. Försök igen med Uppdatera.",
  "needLocation": "Din position behövs för laddare i närheten.",
  "chargeSaveError": "Laddmålet kunde inte sparas. Det tidigare målet återställs; ändra det för att försöka igen.",
  "networkSaveError": "Nätverksvalet kunde inte sparas. Försök igen.",
  "alternativeError": "Laddarna kunde inte hämtas. Uppdatera för att försöka igen.",
  "replaceError": "Laddaren kunde inte ersätta stoppet. Ditt nuvarande stopp finns kvar; försök igen.",
  "replacingCharger": "Byter laddstation…",
  "noRouteChargers": "Ingen laddare hittades inom 60 km från ruttpunkten.",
  "emptyChargerHelp": "Försök uppdatera eller välj ett annat sökområde.",
  "noNearbyChargers": "Ingen snabbladdare hittades inom 50 km från dig.",
  "slideTarget": "Dra för att ändra; sparas automatiskt",
  "preferNetwork": "Föredra {{network}}",
  "showLocation": "Visa min position",
  "backup": "ALTERNATIV LADDNING",
  "chooseCharger": "Välj en laddare",
  "selectedScope": "Dag {{days}} · {{count}} planerade stopp",
  "selectedScopePrevious": "Dag {{days}} · föregående dags slut + {{count}} planerade stopp",
  "days": "Dag {{days}}",
  "filter_all": "Alla",
  "filter_places": "Platser",
  "filter_charge": "Laddning",
  "filter_fuel": "Bränsle",
  "filter_potential": "Förslag",
  "clearFilters": "Rensa kartans innehållsfilter",
  "filters": "Kartfilter",
  "filtersHeading": "FILTER",
  "fitPoints": "Visa alla synliga punkter",
  "viewOptions": "Kartans visningsalternativ",
  "view": "Kartvy",
  "closeFilters": "Stäng kartfilter",
  "daysHeading": "Dagar",
  "mapDays": "Kartans dagar",
  "dayUnit": "dagar",
  "points": "Punkter",
  "pointType": "Typ av kartpunkt",
  "routeDisplay": "Ruttvisning",
  "routeColors": "Ruttfärger",
  "color_day": "Per dag",
  "color_leg": "Per sträcka",
  "placeNames": "Platsnamn",
  "durationDistance": "Tid och avstånd",
  "lineHelp": "Körning visas heldragen. Gång visas streckad.",
  "style": "Kartstil",
  "style_roadmap": "Karta",
  "style_satellite": "Satellit",
  "style_hybrid": "Hybrid",
  "previewDay": "Förhandsvisa en dag",
  "previewHelp": "Följ rutten stopp för stopp",
  "walkingNote": "Gångrutten kan sakna trottoarer eller gångvägar. Kontrollera lokala förhållanden.",
  "resize": "Ändra storlek på kartdetaljer",
  "routeTools": "RUTTVERKTYG",
  "peek": "{{count}} punkter · Omväg · Längs vägen",
  "navigate": "Navigera",
  "tools": "Kartverktyg",
  "detour": "Omväg",
  "alongRoute": "Längs rutten",
  "visible": "SYNLIGT PÅ KARTAN",
  "pointsCount": "{{count}} punkter",
  "potentialCount": "{{count}} förslag",
  "waitingDecision": "Förslag; väntar på beslut",
  "noPoints": "Inga punkter matchar filtren.",
  "tryPlace": "Testa en plats innan den läggs till i planen.",
  "comparePlace": "Jämför valfri plats",
  "betterStop": "Ett bättre nästa stopp.",
  "stopHelp": "Laddning, mat, kaffe, butiker, toaletter och parkering. Sök nära ett stopp eller längs rutten.",
  "findWay": "Hitta längs vägen",
  "chargerArea": "Sökområde för laddare",
  "alongTheRoute": "Längs rutten",
  "lowDetour": "Laddare med liten omväg",
  "aroundMe": "Nära mig",
  "fastNearby": "Snabbladdare i närheten",
  "refreshAlternatives": "Uppdatera laddtillgänglighet och alternativ",
  "alternativeMap": "Karta över alternativa laddare",
  "currentCharger": "Nuvarande laddare",
  "yourLocation": "Din position",
  "you": "Du",
  "currentStop": "Nuvarande stopp",
  "options": "Alternativ",
  "comparing": "Jämför lämpliga alternativ…",
  "liveUnavailable": "Aktuell status saknas",
  "fromYou": "från dig",
  "fromRoute": "från ruttpunkten",
  "impactUnavailable": "Ruttpåverkan saknas",
  "useThis": "Använd denna",
  "loadOptions": "Ladda {{count}} fler alternativ",
  "mapError": "Kartan kunde inte starta",
  "mapLoading": "Hämtar kartan…",
  "mapKey": "Kartnyckel behövs",
  "mapRetry": "Ruttverktygen finns kvar. Öppna fliken igen för att försöka.",
  "offlinePlan": "Planen är fortfarande tillgänglig offline.",
  "calculating": "Beräknar…",
  "stops": "{{count}} stopp",
  "closePlace": "Stäng platsinformation",
  "groupSuggestion": "Gruppförslag",
  "voteTogether": "Rösta tillsammans",
  "arriveBy": "Ta dig dit med",
  "arrivalMode": "Färdsätt till stoppet",
  "availableNow": "Lediga nu",
  "connectorData": "Kontaktinformation",
  "nextLocation": "NÄSTA STOPP",
  "alternatives": "Alternativ",
  "maps": "Kartor",
  "findAround": "Hitta runt stoppet",
  "viewDecision": "Visa beslut",
  "stationData": "Stationsdata varierar mellan leverantörer",
  "updatedNow": "uppdaterat nu",
  "updatedMinutes": "uppdaterat för {{count}} min sedan",
  "updatedHours": "uppdaterat för {{count}} tim sedan",
  day: 'Dag {{number}}', closePreview: 'Stäng dagsförhandsvisning', previewHeading: 'DAGSFÖRHANDSVISNING', previewSelect: 'Förhandsvisa dag', previewRegion: 'Förhandsvisning av dagens rutt',
  arrivalIncluded: 'Ankomststräcka ingår', todaysStops: 'Dagens stopp', hideArrival: 'Dölj lång ankomststräcka', includeArrival: '+ Ta med ankomst',
  perspective: 'Förhandsvisningsperspektiv', tiltedView: 'Lutad kartvy', pauseFollow: 'Pausa kameraföljning', resumeFollow: 'Återuppta kameraföljning', following: 'Följer', followRoute: 'Följ rutten',
  previewComplete: 'Dagsförhandsvisning klar', start: 'Start', finish: 'Slut', nextStop: 'Nästa stopp', streetView: 'Öppna stoppet i Google Street View', streetHelp: 'Öppnar Google Maps; bilder beror på täckning', street: 'Gata ↗',
  dayProgress: 'Dagens framsteg', previousStop: 'Föregående stopp', playDay: 'Spela dagen', pauseDay: 'Pausa dagen', playbackSpeed: 'Uppspelningshastighet',
  previewDisclaimer: 'Förhandsvisning, inte navigering', pauseCameraHelp: 'Flytta kartan för att pausa kameraföljningen.', noPreviewRoute: 'Dagen behöver en beräknad rutt mellan två stopp med position.', previewPosition: 'Position i ruttförhandsvisning',
  compareHeading: 'OMVÄGENS EFFEKT', tryTitle: 'Prova en plats', alongTitle: 'Hitta längs rutten', compareHelp: 'Välj en plats och se hur den ändrar rutten.',
  placement: 'Placering i rutten', changePlacement: 'Ändra placering', insertAfter: 'Lägg efter', insertBefore: 'Före', addToDay: 'Lägg till på dag', between: '{{from}} → {{to}}',
  searchNear: 'Sök nära {{place}}', searchBetween: 'Sök {{type}} mellan {{from}} och {{to}}', route: 'rutten', comparingRoads: 'Jämför båda rutterna…',
  compareError: 'Rutten kunde inte jämföras. Din plats finns kvar; försök igen.', compareAgain: 'Jämför igen', noCompareRoute: 'Lägg till två stopp med position för att jämföra en plats.', routeChanged: 'Rutten eller fordonet ändrades. Jämför platsen igen för en aktuell uppskattning.',
  ifAdded: 'OM VI LÄGGER TILL', arrivalAtStop: '{{value}}% vid detta stopp', currentRoute: 'Nuvarande rutt', proposedRoute: 'Med detta stopp', addNow: 'Lägg till nu', askGroup: 'Fråga gruppen',
  adding: 'Lägger till…', proposing: 'Skickar…', addError: 'Stoppet kunde inte läggas till. Ditt val finns kvar; försök igen.', proposalError: 'Förslaget kunde inte skickas till gruppen. Försök igen.',
  editorHelp: 'En redigerare kan lägga till platsen eller fråga gruppen.', proposalHelp: 'Förslaget finns på kartan tills gruppen har bestämt sig.', proposalTitle: 'Lägga till {{place}} på rutten?', potentialBetween: 'Föreslaget stopp mellan {{from}} och {{to}}.', potentialStop: 'Föreslaget ruttstopp.', addedBetween: 'Tillagt mellan {{from}} och {{to}}.', chargerRefreshError: 'Laddinformationen kunde inte uppdateras. Försök igen.'
};
export const mapExperienceTranslations = { en, tr, sv };
